import { Component, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { FilesListComponent } from './files-list.component';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { Utils } from "../../shared/utils";
import { FilesService } from './files.service';

@Component({
    selector: 'convfact-fileopen',
    templateUrl: './files-dialog-file.component.html',
    styleUrls: ['./files.component.css'],
    standalone: false
})

export class FilesDialogFileComponent {

    fileName: string;
    fileUpload: Blob;
    path: string = this.data.path;
    error_msg: string;
    error: boolean = false;
    done: boolean = false;
    upload: boolean = false;
    error_ext: boolean = false;
    width: number = 0;
    height: number = 0;
    size = false;

    constructor(
        public dialogRef: MatDialogRef<FilesListComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public snackBar: MatSnackBar,
        private fileService: FilesService
    ) { }

    displayInfo(message: string): void {
        const options = new MatSnackBarConfig();
        options.duration = 10000;
        options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
    }

    uploadImage(event) {
        this.error = false;
        if (this.fileName == null || this.fileName == "") {
            this.error = true;
            this.error_msg = "Debe indicar un nombre al fichero";
        } else {
            this.upload = true;
            let type = "";
            const fileList: FileList = event.target.files;
            const afterDot = fileList[0].name.substr(fileList[0].name.indexOf('.'));
            if (afterDot.includes("png") || afterDot.includes("PNG") ||
                afterDot.includes("jpg") || afterDot.includes("JPG") ||
                afterDot.includes("jpeg") || afterDot.includes("JPEG")) {
                type = "Image";
            } else if (afterDot.includes("pdf") || afterDot.includes("PDF")) {
                type = "PDF";
            } else if (afterDot.includes("docx") || afterDot.includes("DOCX")) {
                type = "Word";
            } else if (afterDot.includes("xlsx") || afterDot.includes("XLSX")) {
                type = "Excel";
            } else {
                this.error = true;
                this.upload = false;
                this.error_ext = true;
                this.error_msg = "El fichero debe ser una imagen (png, jpg), pdf, docx o xlsx, por favor, vuelva a seleccionar.";
            }

            alert(fileList.length);

            if (fileList.length > 0 && !this.error && fileList.length <= 10) {
                if (this.data.storageSpent + Utils.FromByteToGb(fileList[0].size) < this.data.storageCapacity) {
                    const file: File = fileList[0];
                    const self = this;

                    if (type === "Image") {
                        const img = new Image();
                        img.src = window.URL.createObjectURL(file);

                        img.onload = function () {
                            window.URL.revokeObjectURL(img.src);
                            if (img.naturalWidth > 200 && img.naturalHeight > 200) {
                                self.fileService.createFile(file, type, self.fileName, self.path).then(response => {
                                    self.done = true;
                                    // self.displayInfo("Fichero guardado correctamente");
                                    self.upload = false;
                                })
                            } else {
                                self.displayInfo("La imagen debe ser superior a 200px");
                                self.size = true;
                                self.upload = false;
                            }
                        }
                    } else {
                        self.fileService.createFile(file, type, self.fileName, self.path)
                            .then(response => {
                                self.done = true;
                                // self.displayInfo("Fichero guardado correctamente");
                                self.upload = false;
                            })
                    }
                } else {
                    this.error = true;
                    this.upload = false;
                    this.error_ext = true;
                    this.error_msg = "Ya ha superado su capacidad de almacenamiento.";
                }
            } else {
                this.displayInfo("Debe seleccionar mínimo 1 fichero, y máximo 10.")
            }
        }
    }

    closeDialog() {
        this.dialogRef.close();
    }

}